module.exports = __webpack_public_path__ + "df4b70ab568f76ceefddc49340b1a027.pdf";